import { useMutation, useQuery } from 'react-query'
import axios from 'axios'
import { CreateContractRequest, CreateContractResponse, InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { baseUrl, GenericQueryOptions } from '.'
import { OkAppsMeetingRecord } from '../dtos/OkAppsMeetingRecord'

const wizardApiUrl = process.env.REACT_APP_WIZARD_ADDON_API
const url = `${baseUrl}/${wizardApiUrl}`

export const useSaveInsuranceParams = () =>
    useMutation((insuranceParams: InsuranceParamsDto) =>
        axios.post(`${url}/SaveInsuranceParams`, insuranceParams))

const fetchInsuranceParams = (paramsId: string) =>
    axios.get<InsuranceParamsDto>(`${url}/GetInsuranceParams?paramsId=${paramsId}`)

export const useGetInsuranceParamsAddon = (paramsId: string, options?: GenericQueryOptions<InsuranceParamsDto>) =>
    useQuery(['getInsuranceParams', paramsId]
        , () => fetchInsuranceParams(paramsId)
        , options)

export const useSaveSelectedAddonInsurance = () =>
    useMutation((paramsId: number) =>
        axios.post(`${url}/SaveSelectedAddonInsurance?paramsId=${paramsId}`, undefined))

const saveMeetingRecord = (meetingRecord: OkAppsMeetingRecord) =>
    axios.post(`${url}/SaveMeetingRecord`, meetingRecord)

export const useSaveMeetingRecord = () =>
    useMutation(saveMeetingRecord)

const createContract = (request: CreateContractRequest) =>
    axios.post<CreateContractResponse>(`${url}/CreateContract`, request)

export const useCreateContract = () =>
    useMutation(createContract)